import React, {useEffect} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Page({children}) {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [children]);

    return(
        <>
            <Header/>

            {children}

            <Footer/>
        </>
    )
}

export default Page;